import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Checkbox, Select } from 'antd';

import '../../../css/textsPredefined.css';
import '../../views/concesionario/concesionario.css'
import { useRegiones, useZonas } from '../../../hooks/Front/concesionarios/useConcesionarios';
import useServicios from '../../../hooks/Front/servicioTecnico/useServicios'
import { SeccionZonas } from '../../views/concesionario/Concesionarios';
import clienteAxios from '../../../configAxios/configAxios';
import { errorSwal } from '../../../helper/swalHelpers';

const { Option } = Select;

const Red = () => {
    const [servicios, setServicios] = useState([])
    const [zona, setZona] = useState(undefined);
    const [region, setRegion] = useState(undefined);

    const [concesionarios] = useServicios(servicios, zona, region);
    const [zonas, isLoadingZona] = useZonas();
    const [regiones, isLoadingRegiones] = useRegiones(zona);

    const [datos, setDatos] = useState([]);
    const [dataLegal] = datos?.filter(element => element.Etiqueta === 'LEGAL');

    useEffect(() => {
        const fetchDatosFooter = async () => {
            try {
                let response = await clienteAxios.get('Parametro/activo/SERV_TECNICO');
                if (response.status === 200) {
                    let data = response.data.data;
                    setDatos(data);
                    return;
                }
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            } catch (error) {
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            }
        }
        fetchDatosFooter();
    }, []);

    const handleChangeZona = (value) => {
        setZona(value);
        setRegion(undefined);
    }

    const handleChangeRegion = (value) => {
        setRegion(value);
    }

    const handleChangeServicios = (value) => {
        setServicios(value);
    }


    let deshabilitarRegion = regiones === undefined ? true : regiones.length < 1 ? true : false;
    return (
        <>
            <Row>
                <Col className="text-center">
                    <h2 className="bold-text-hyundai wow fadeInDown ml-1 mt-md-5 pt-md-2 mb-md-3 f-responsive">Selecciona el servicio que necesitas</h2>
                </Col>
            </Row>
            <Row>
                <Col className="text-center mt-2 my-md-4">
                    <p className="parrafo-hyundai text-left d-md-none ml-1 f-responsive-10">Filtrar por:</p>
                    <Checkbox.Group value={servicios} onChange={handleChangeServicios}>
                        <Checkbox className="px-md-5 parrafo-hyundai" value="servicio"><p className="d-block d-md-inline font-boxes-c f-responsive-10 pr-3 pr-md-0 mb-0">Servicio técnico</p></Checkbox>
                        <Checkbox className="px-md-5 parrafo-hyundai" value="repuestos"><p className="d-block d-md-inline font-boxes-c f-responsive-10 pl-3 pl-md-0 mb-0">Repuestos</p></Checkbox>
                    </Checkbox.Group>
                </Col>
            </Row>
            <Row className="my-md-4 mb-md-5 pb-3  border-row-zona">
                <Col xs={6} className="text-right pr-1 pr-md-3 mb-2 mb-md-5">
                    <Select className="w-select-conce text-left pr-1 concesionario-select parrafo-hyundai f-responsive-10" value={zona} onChange={handleChangeZona} loading={isLoadingZona} placeholder="Zona">
                        {zonas && zonas.length > 0 &&
                            zonas.map((zona, index) => <Option key={index} value={zona.Zona} >{zona.Zona}</Option>)
                        }
                    </Select>
                </Col>
                <Col xs={6} className="text-left pl-1">
                    <Select className="w-select-conce parrafo-hyundai pl-1 concesionario-select f-responsive-10" onChange={handleChangeRegion} value={region} disabled={deshabilitarRegion} loading={isLoadingRegiones} placeholder="Región">
                        {regiones && regiones.length > 0 &&
                            regiones.map((region, index) => <Option key={index} value={region.idRegion}>{region.Region}</Option>)
                        }
                    </Select>
                </Col>
                <Col xs={12} md={10} lg={8} className="mx-auto mt-3 mb-0 text-center">
                    <p className='mb-0 bold-text-hyundai f-responsive htmlHyundai' dangerouslySetInnerHTML={{ __html: dataLegal?.Descripcion}}></p>
                </Col>
            </Row>
            {concesionarios && concesionarios.length > 0 &&
                concesionarios.map((zona, i) => <SeccionZonas key={i} zona={zona} servicios={true} />)
            }
        </>
    );
}

export default Red;